export default {
      id: "svg-icon-dislike-usage",
      viewBox: "0 0 14 13",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-dislike",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/dislike.svg
// module id = enOV
// module chunks = 4